/* Header search on mobile: the search icon opens search without opening the menu drawer.
 * Oct 2026: it opens the same search panel as desktop (#search-modal: popular searches, categories, recently viewed,
 * live results), styled as a sheet from the top in dh-search-panel.css. The plain search bar below is the fallback
 * when that panel is missing or not ready yet. */
(() => {
  'use strict';
  const openPanel = () => {
    const modal = document.getElementById('search-modal');
    if (!modal || typeof modal.showDialog !== 'function') return false;
    modal.showDialog();
    requestAnimationFrame(() => modal.querySelector('predictive-search-component input[type="search"]')?.focus());
    return true;
  };
  const setBar = (nav, open) => {
    const bar = nav.querySelector('.dh-nav-searchbar');
    const button = nav.querySelector('.dh-nav-mobile-search-open');
    if (!bar || !button) return;
    bar.dataset.open = String(open);
    bar.inert = !open;
    button.setAttribute('aria-expanded', String(open));
    if (open) setTimeout(() => bar.querySelector('input')?.focus(), 30);
    else if (bar.contains(document.activeElement)) button.focus();
  };
  document.addEventListener('click', event => {
    const nav = event.target.closest?.('dh-shopify-navigation');
    if (event.target.closest?.('.dh-nav-mobile-search-open')) { if (!openPanel()) setBar(nav, true); return; }
    if (event.target.closest?.('.dh-nav-searchbar-close')) { setBar(nav, false); return; }
    document.querySelectorAll('dh-shopify-navigation').forEach(n => {
      const bar = n.querySelector('.dh-nav-searchbar');
      if (bar?.dataset.open === 'true' && !bar.contains(event.target)) setBar(n, false);
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('dh-shopify-navigation').forEach(n => {
      if (n.querySelector('.dh-nav-searchbar')?.dataset.open === 'true') setBar(n, false);
    });
  });
  matchMedia('(min-width:1024px)').addEventListener('change', e => {
    if (e.matches) document.querySelectorAll('dh-shopify-navigation').forEach(n => setBar(n, false));
  });
})();
